export const FIRST_OPTION = 'First Option';
export const ROBOT_DETAIL_BREADCRUMB = 'Robot detail breadcrumb';
export const FORM_DETAIL_BREADCRUMB = 'Form Detail Breadcrumb';
